import { createContext, useContext, useMemo, useState, type ReactNode } from 'react';

type AssistenteUi = {
  aberto: boolean;
  presente: boolean;
  /** Celular: o painel saiu da frente para um destaque aparecer; a pilula "Voltar para a Mia" reabre. */
  recolhida: boolean;
  abrir: () => void;
  recolher: () => void;
  minimizar: () => void;
  fechar: () => void;
};

const AssistenteUiContext = createContext<AssistenteUi | null>(null);

export function AssistenteProvider({ children }: { children: ReactNode }) {
  const [aberto, setAberto] = useState(false);
  const [presente, setPresente] = useState(true);
  const [recolhida, setRecolhida] = useState(false);
  const valor = useMemo<AssistenteUi>(
    () => ({
      aberto,
      presente,
      recolhida,
      abrir: () => {
        setPresente(true);
        setAberto(true);
        setRecolhida(false);
      },
      recolher: () => {
        setAberto(false);
        setRecolhida(true);
      },
      minimizar: () => {
        setAberto(false);
        setRecolhida(false);
      },
      fechar: () => {
        setAberto(false);
        setPresente(false);
        setRecolhida(false);
      },
    }),
    [aberto, presente, recolhida],
  );
  return <AssistenteUiContext.Provider value={valor}>{children}</AssistenteUiContext.Provider>;
}

export function useAssistenteUi(): AssistenteUi {
  return (
    useContext(AssistenteUiContext) ?? {
      aberto: false,
      presente: false,
      recolhida: false,
      abrir: () => undefined,
      recolher: () => undefined,
      minimizar: () => undefined,
      fechar: () => undefined,
    }
  );
}
